import axios from 'axios';
import { ENDPOINTS } from './_config';

export const normalizePhoneNumber = (phoneNumber) => {
  const digits = phoneNumber.replace(/\D/g, ''); // Remove all non-digit characters
  return digits.startsWith('1') ? `+${digits}` : `+1${digits}`;
};

export const fetchCallLogs = async (rawPhoneNumber) => {
 
  
  try {
    const response = await axios.get(`${ENDPOINTS.CONVERSATION.CALL_LOGS}${rawPhoneNumber}`);

    return response.data;
  } catch (error) {
    console.error('Failed to fetch call logs:', error);
    return null;
  }
};

export const fetchAIAgentCallLogs = async (patientTrialJuncID) => {
  try {
    const response = await axios.get(`${ENDPOINTS.CONVERSATION.AI_AGENTS_CALL_LOGS}?patientTrialJuncID=${patientTrialJuncID}`);

    return response.data;
  } catch (error) {
    console.error('Failed to fetch call logs:', error);
    return null;
  }
};

export const fetchAIAgentCallSignUrls = async (voiceAgentCallId) => {
  try {
    const response = await axios.get(`${ENDPOINTS.CONVERSATION.AI_AGENTS_CALL_SIGN_URL}?voiceAgentCallId=${voiceAgentCallId}`);

    return response.data;
  } catch (error) {
    console.error('Failed to fetch call logs:', error);
    return null;
  }
};


